import{ Modal, FC, useMemo} from 'external/react'

import ModalAcceptCancelFooter from 'components/ModalAcceptCancelFooter'
import { clearedSelectUser, Package, PackageUser } from 'types/context/package'
import usePackage from 'context/package-context/hook'
import SearchUser from './SearchUser'
import AddUserButton from './AddUserButton'
import SelectUserTable from './SelectUserTable'
import AddUserModal from '../AddUser'
import { isUUID } from 'external/lodash'
import { notifySuccess } from 'components/Notify'

type SelectUserModalProps = {
	role: 'Student' | 'Tutor'
	onSelectUser: (role: string, selectedUser: PackageUser|null, purchase: Package) => void
}

const SelectUserModal: FC<SelectUserModalProps> = props => {

	const {role, onSelectUser} = props

	const {update, state: { modals}, addUser} = usePackage()

	const modal = useMemo(() => modals[`select${role}`], [modals, role])

	const {open, users, search, selectedUser, purchase} = modal

	function handleUserSelected () {
		if (purchase && purchase[role.toLowerCase()] !== selectedUser) {
			onSelectUser(role, selectedUser, purchase)
		}
		handleClose()
	}

	function handleClose() {
		update({modals: {[`select${role}`]: {$shallow: clearedSelectUser}}})
	}

	function handleSelectUser (user:PackageUser) {
		update({modals: {[`select${role}`]: {selectedUser: {$set: user}}}})
	}

	async function handleUserCreation(role, modal) {

		const {first_name, last_name, phone, email} = modal
		const user = {first_name, last_name, phone, email}
		const response = await addUser(role, user)
		const newUser = response.data || {}
		if (isUUID(newUser.id)) {
			update({modals: {[`select${role}`]: {
				selectedUser: {$set: newUser},
				users: {$splice: [[0, 0, newUser]]}
			}}})
		}
		notifySuccess(`${role === 'Student' ? 'Estudiante' : 'Tutor'} añadido exitosamente.`)
	}

	const roleName = useMemo(() => role === 'Student' ? 'estudiante' : 'tutor', [role])

    return (
			<Modal show={open} onHide={handleClose} size='lg' centered >
				<Modal.Header closeButton>
					<h5 className='text-capitalize' style={{ fontFamily: 'Arial, sans-serif', margin: '0' }} >Seleccione {roleName}</h5>
				</Modal.Header>
				<Modal.Body>
					<div className='row'>
						<SearchUser role={role} search={search} />
						<AddUserButton role={role} />
						<AddUserModal onAddUser={handleUserCreation} role={role}/>
					</div>
					<div className='row'>
						<div className='col-md-12 mt-3'>
							<SelectUserTable role={role} selectedUser={selectedUser} onUserSelected={handleSelectUser} search={search} users={users} />
						</div>
					</div>
				</Modal.Body>
				<ModalAcceptCancelFooter onCancel={handleClose} onAccept={handleUserSelected}/>
			</Modal>
        )
}

export {SelectUserModal as default}